import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useMemo } from 'react';
import { UNCONSTRAINED_SIZE_KEY } from './useImage';
/**
 * The talon for working with ResourceImages.
 * Does all the work of generating src, srcSet, and sizes attributes.
 *
 * @param {func}    props.generateSrcset - A function that returns a srcSet.
 * @param {number}  props.height - The height to request for the fallback image for browsers that don't support srcset / sizes.
 * @param {string}  props.resource - The Magento path to the image ex: /v/d/vd12-rn_main_2.jpg
 * @param {func}    props.resourceUrl - A function that returns the full URL for the Magento resource.
 * @param {string}  props.type - The Magento image type ("image-category" / "image-product"). Used to build the resource URL.
 * @param {number}  props.width - The width to request for the fallback image for browsers that don't support srcset / sizes.
 * @param {Map}     props.widths - The map of breakpoints to possible widths used to create the img's sizes attribute.
 * @param {number}   props.ratio is the image width to height ratio. Defaults to 4/5.
 */

export var useResourceImage = function useResourceImage(props) {
  var generateSrcset = props.generateSrcset,
      generateUrl = props.generateUrl,
      height = props.height,
      resource = props.resource,
      type = props.type,
      width = props.width,
      widths = props.widths,
      ratio = props.ratio;
  var src = useMemo(function () {
    return generateUrl(resource, type)(width, height);
  }, [generateUrl, height, resource, type, width]);
  var srcSet = useMemo(function () {
    return generateSrcset(resource, type, ratio);
  }, [generateSrcset, resource, type, ratio]); // Example: 100px
  // Example: (max-width: 640px) 50px, 100px

  var sizes = useMemo(function () {
    if (!widths) {
      return width ? "".concat(width, "px") : '';
    }

    var result = [];

    var _iterator = _createForOfIteratorHelper(widths),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
            breakpoint = _step$value[0],
            _width = _step$value[1];

        if (breakpoint !== UNCONSTRAINED_SIZE_KEY) {
          result.push("(max-width: ".concat(breakpoint, "px) ").concat(_width, "px"));
        }
      } // Add the unconstrained size at the end.

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    result.push("".concat(widths.get(UNCONSTRAINED_SIZE_KEY), "px"));
    return result.join(', ');
  }, [width, widths]);
  return {
    sizes: sizes,
    src: src,
    srcSet: srcSet
  };
};